// extracted by mini-css-extract-plugin
export default {"container":"YN-z","title":"ZN-z","link":"_N-z"};